import React from "react";
import { Grid, Typography, TextField } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import ja from "date-fns/locale/ja";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import toISOStringWithTimezone from "../../../../functions/toISOStringWithTimezone";

export default function DateField({ dateFromValue, dateToValue, classes, onChange }) {
  const handleChangeFrom = (date) => {
    if (!date) return;
    onChange({ date_from: toISOStringWithTimezone(date).split("T")[0] });
  };

  const handleChangeTo = (date) => {
    if (!date) return;
    onChange({ date_to: toISOStringWithTimezone(date).split("T")[0] });
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={ja}
      dateFormats={{ monthAndYear: "yyyy年MM月" }}
    >
      <Grid
        item
        xs={12}
        sm={1.5}
        sx={{
          fontWeight: "bold",
          paddingLeft: { sm: "20px" },
          paddingTop: "10px",
          paddingBottom: { xs: "10px", sm: "20px" },
        }}
      >
        日付
      </Grid>
      <Grid
        item
        xs={5.5}
        sm={3.5}
        sx={{
          borderLeft: 1,
          borderColor: "#F2F3F4",
          paddingTop: "10px",
          paddingBottom: "20px",
          paddingLeft: { sm: "20px" },
        }}
      >
        <DesktopDatePicker
          value={dateFromValue}
          format="yyyy年M月d日"
          onChange={handleChangeFrom}
          renderInput={(params) => (
            <TextField {...params} className={classes?.inputArea} />
          )}
        />
      </Grid>
      <Grid
        item
        xs={1}
        sx={{
          borderLeft: 1,
          borderColor: "#F2F3F4",
          paddingTop: { sm: "10px" },
          paddingBottom: "20px",
        }}
      >
        <Typography align="center">〜</Typography>
      </Grid>
      <Grid
        item
        xs={5.5}
        sm={3.5}
        sx={{
          borderLeft: 1,
          borderColor: "#F2F3F4",
          paddingTop: "10px",
          paddingBottom: "20px",
          paddingLeft: { sm: "20px" },
        }}
      >
        <DesktopDatePicker
          value={dateToValue}
          format="yyyy年M月d日"
          onChange={handleChangeTo}
          renderInput={(params) => (
            <TextField {...params} className={classes?.inputArea} />
          )}
        />
      </Grid>
      <Grid item sm={2.5} />
    </LocalizationProvider>
  );
}